<template>
<div>
    <div class="row">
        <div class="col-9"/>
        <div class="col-2">
            <input type="text" class="form-control" v-model="textoBusqueda"/>
        </div>
        <div class="col-1">
            <input type="button" value="Filtrar" class="form-control" @click="filtrarAcuerdos"/>
        </div>
    </div>
    <div class="new-row">
  <table class="table table-striped table-light table-hover" id="tablaAcuerdos">
    <thead class="thead-dark">
      <tr>
        <th class="col-1">No.</th>
        <th class="col-3">Documento</th>
        <th class="col-4">Presuntos Responsables</th>
        <th class="col-4">Extracto</th>
      </tr>
    </thead>
    <tbody class="text-dark">
      <tr
        v-for="(acuerdo, indice) in acuerdosDelDia"
        v-bind:key="acuerdo.acuerdoId"
      >
        <td>{{ indice + 1 }}</td>
        <td>{{ acuerdo.denuncia.consecutivo }}</td>
        <td>
          <span
            v-for="persona in acuerdo.denuncia.personas"
            v-bind:key="persona.personaId"
          >
            {{ persona.nombre + " " + persona.paterno + " " + persona.materno }}
          </span>
        </td>
        <td>{{ acuerdo.extracto }}</td>
      </tr>
      <tr v-if="acuerdosDelDia.length == 0">
        <td colspan="2">No se encontraron acuerdos.</td>
      </tr>
    </tbody>
  </table>
  </div>
  </div>
</template>
<script>
import Vue from "vue";
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import store from "@/store/index";
import { Acuerdo } from "@/components/SIFA/Comun/Modelos/Acuerdo.js";
export default {
  data() {
    return {
      _acuerdosDelDia: [],
      acuerdosDelDia: [],
      textoBusqueda: ""
    };
  },
  props: { prop_acuerdosDelDia: Array[Acuerdo] },
  components: {},
  methods: {
      filtrarAcuerdos(){
          this.acuerdosDelDia = this._acuerdosDelDia? this._acuerdosDelDia.filter(ad => ad.denuncia.consecutivo.includes(textoBusqueda) || ad.extracto.includes(textoBusqueda))
          : [];
      }
  },
  mounted: function mounted() {
    if (this.prop_acuerdosDelDia){
      this.acuerdosDelDia = this.prop_acuerdosDelDia;
      //this.filtrarAcuerdos();
    }
  },
  computed: {},
};
</script>

<style scoped>
.new-row {
  margin-top: 20px;
}
.fa,
.fas {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/SIFA/Reportes/ListasDeAcuerdosPublicadas/TablaAcuerdosDelDia.vue